<template>
    <div>
        <fields-section />
        <todos-section />
        <users-section />
        <logo-section />
    </div>
</template>

<script>
import FieldsSection from './FieldsSection';
import TodosSection from './TodosSection';
import UsersSection from './UsersSection';
import LogoSection from './LogoSection';

export default {
    components: {
        FieldsSection,
        TodosSection,
        UsersSection,
        LogoSection,
    },
};
</script>
